import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { getRequest, postRequest } from "../interceptor/interceptor";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { RiProgress6Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { IoBarChart } from "react-icons/io5";
import { userLogoutOp } from "../../redux/operations/user.operations.js";
import CircularChart from "../CircularChart/CircularChart";
import StackedBarChart from "../BarChart/BarChart";
import NavigationTab from "../NavigationTab/NavigationTab.jsx";
import {
  Grid,
  Card,
  Paper,
  Container,
  CardHeader,
  Typography,
} from "@mui/material";
import { GET_TICKETS, TICKET_STATS } from "../../apiConst";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
import TicketsList from "./TicketsList";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  dashboardTableHeader,
  grievanceTableHeader,
} from "../../Fields/grievanceFields";
import SelectDropdown from "../../Common/SelectDropdown";
import TicketPivotTable from "../Ticketpivot/Ticketpivot.jsx";
import Profile from "../profile/Profile.jsx";
import DateRangePicker from "../../Common/DateRangePicker.jsx";

const MPLadsDashboard = () => {
  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const headers = dashboardTableHeader;

  const FilterOptions = grievanceTableHeader;

  const userData = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(rowsPerPage);
  const [tableRowsData, setTableRowsData] = useState([]);
  const [filterByText, setFilterByText] = useState("");
  const [tabsData, setTabsData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [newCount, setNewCount] = useState(0);
  const [inProgressCount, setInProgressCount] = useState(0);
  const [resolvedCount, setResolvedCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [newTicketsData, setNewTicketsData] = useState([]);
  const [inProgressData, setInProgressData] = useState([]);
  const [resolvedData, setResolvedData] = useState([]);
  const [rejectedData, setRejectedData] = useState([]);
  const navigate = useNavigate();
  const [searchVal, setSearchVal] = useState("");
  const [requestMode, setRequestMode] = useState(null);
  const [requestType, setRequestType] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [dataState, setDataState] = useState();
  const [pivotdata, setPivotdata] = useState([]);
  const dispatch = useDispatch();
  const [requestBarMode, setRequestBarMode] = useState("state");
  const [requestCircularMode, setRequestCircularMode] = useState("state");
  useEffect(() => {
    fetchListData();
    import("../../utils/taskNavTabs.js").then((data) => {
      setTabsData(data.taskNavTabs);
    });
  }, [startDate, endDate]);

  const fetchListData = (
    pg = 1,
    size = 10,
    search = "",
    selectedRequestMode = requestMode,
    selectedRequestType = requestType,
    searchKey = null
  ) => {
    setIsLoading(true);

    let payload = {
      // page: pg,
      // pageSize: size,
    };

    // Conditionally add values if they are changed
    if (startDate) payload.startDate = moment(startDate).format("YYYY-MM-DD");
    if (endDate) payload.endDate = moment(endDate).format("YYYY-MM-DD");
    if (selectedRequestMode && selectedRequestMode!=='select') payload.requestMode = selectedRequestMode;
    if (selectedRequestType && selectedRequestType !=='select') selectedRequestMode==="private" ?payload.privateRequestType = selectedRequestType:payload.requestType = selectedRequestType;

    const { searchField } = getValues();
    const key = searchKey || searchField;

    if (key && search) {
      payload[key] = search;
    }
    postRequest(TICKET_STATS, payload)
      .then((res) => {
        console.log("res", res);
        const {
          newTicket_count,
          inprogress_count,
          resolved_count,
          rejected_count,
          total,
          newTicket,
          inprogress,
          rejected,
          resolved,
        } = res.data;
        setPivotdata(res.data);
        // setTableRowsData(result || []);
        setTotalCount(total);
        setNewCount(newTicket_count);
        setInProgressCount(inprogress_count);
        setResolvedCount(resolved_count);
        setNewTicketsData(newTicket || []);
        setInProgressData(inprogress || []);
        setResolvedData(resolved || []);
        setRejectedCount(rejected_count);
        setRejectedData(rejected || []);
        setIsLoading(false);
        setIsDisplay(true);
      })
      .catch(() => {
        setIsLoading(false);
        setNewCount(0);
        setInProgressCount(0);
        setResolvedCount(0);
        setRejectedCount(0);
        setNewTicketsData([]);
        setInProgressData([]);
        setResolvedData([]);
        setRejectedData([]);
        setTotalCount(0);
      });
  };

  const onEdit = (task) => {
    navigate("/stepper-form", {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isEdit: true,
      },
    });
  };
  const onView = (task) => {
    navigate("/stepper-form", {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isView: true,
      },
    });
  };
  const onStepperForm = (task) => {
    navigate("/stepper-form", {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isView: false,
      },
    });
  };
  const handleLogout = () => {
    dispatch(userLogoutOp());
    localStorage.removeItem("userAuthToken");
    localStorage.removeItem("locationIp");
    navigate("/seva-login");
  };
  const handleSearchFieldDropdown = (e) => {
    const selectedField = e.target.value;
    setValue("searchField", selectedField);
    setSearchField(selectedField);
    fetchListData(1, rowsPerPage, searchVal, requestMode, selectedField);
  };

  const handleRequestModeDropdown = (e) => {
    const selectedMode = e.target.value
    console.log("selectedMode", selectedMode);
    setValue("requestMode", selectedMode);
    setRequestMode(selectedMode);
    fetchListData(1, rowsPerPage, searchVal, selectedMode);
    setRequestCircularMode(selectedMode==='select'?'state':selectedMode);
    setRequestBarMode(selectedMode==='select'?'state':selectedMode);
  };

  const handleRequestTypeDropdown = (e) => {
    const selectedType = e.target.value
    setValue("requestType", selectedType);
    setRequestType(selectedType);
    fetchListData(1, rowsPerPage, searchVal, requestMode, selectedType);
    setRequestCircularMode(requestMode==='select'?'state':requestMode);
    setRequestBarMode(requestMode==='select'?'state':requestMode);
  };

  const debounceSearch = debounce((searchValue) => {
    setSearchVal(searchValue);
    fetchListData(
      1,
      rowsPerPage,
      searchValue,
      requestMode,
      requestType,
      searchField
    );
  }, 750);

  const handleChangeSearch = (e) => {
    debounceSearch(e.target.value);
  };

  const cancelSearch = () => {
    setSearchVal("");
    fetchListData(1, rowsPerPage, "");
  };

  const componentDisplay = () => {
    const cells = FilterOptions?.filter(
      (cell) =>
        cell.id === "ticketNo" ||
        cell.id === "requestTitle" ||
        cell.id === "applicantName" ||
        cell.id === "ticketCreatedBy" ||
        cell.id === "assignedTo" ||
        cell.id === "referralName"
    );
    return (
      <div className="text-center mb-[-15px]">
        {FilterOptions.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] w-full border-1 bg-light py-1.5 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };
  console.log("pivotdata", pivotdata);

  const stats = [
    { label: "Request Mode", value: requestMode==="select"?"NA":requestMode || "NA", color: "" },
    // { label: "Request Type", value: requestType || "NA" },
    { label: "New Tickets", value: newCount || 0, color: "#2f4b7c" },
    { label: "In Progress", value: inProgressCount || 0, color: "#f28927" },
    { label: "Rejected", value: rejectedCount || 0, color: "#c44627" },
    { label: "Resolved", value: resolvedCount || 0, color: "#5D883C" },
  ];

  return (
    <div className="w-full">
      {/* <div className="flex flex-col flex-wrap xl:flex-nowrap bg-blueBg w-full p-3 rounded-lg justify-between items-center m-2">
      
        <div className="flex flex-wrap xl:flex-nowrap justify-between w-full items-center p-2">
          <Typography variant="h5" className="text-white font-bold">
            SEVA Grievance
          </Typography>

          
          {userData.role === "Director" && (
            <nav className="mx-2 my-3 flex space-x-6 text-white font-semibold">
              <Link
                to="https://www.rammnk.com"
                target="_blank"
                className="transition-transform hover:scale-105"
              >
                Home
              </Link>
              <Link
                to="/calendar"
                className="transition-transform hover:scale-105"
              >
                Calendar
              </Link>
              <Link
                onClick={handleLogout}
                className="transition-transform hover:scale-105"
              >
                Logout
              </Link>
            </nav>
          )}

         
          <div className="flex flex-wrap items-center gap-4 my-3 lg:my-0 ">
          
            <div className="flex flex-col md:flex-row gap-4 items-center ">
              <div className="w-full">
                <label className="block text-sm text-white font-medium mb-1">
                  Start Date
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd MMM yyyy"
                  className="bg-white text-black px-2 py-1 rounded-md shadow-sm w-full"
                  placeholderText="Start Date"
                />
              </div>
              <div className="w-full">
                <label className="block text-sm text-white font-medium mb-1">
                  End Date
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="dd MMM yyyy"
                  className="bg-white text-black px-2 py-1 rounded-md shadow-sm w-full"
                  placeholderText="End Date"
                  minDate={startDate}
                />
              </div>
            </div>
            <DashboardDatePicker setStartDate={setStartDate} setEndDate={setEndDate}/>
            <div className="hidden lg:block">
              <Profile />
            </div>
          </div>
        </div>

       
        <Grid container spacing={1}>
          <Grid item xs={6} md={2}>
            <label className="block text-white font-medium text-sm mb-1">
              Start Date
            </label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd MMM yyyy"
              className="bg-white text-black px-2 py-1 rounded-md shadow-sm"
              placeholderText="Start Date"
            />
          </Grid>
          <Grid item xs={6} md={2}>
            <label className="block text-white font-medium text-sm mb-1">
              End Date
            </label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="dd MMM yyyy"
              className="bg-white text-black px-2 py-1 rounded-md shadow-sm"
              placeholderText="End Date"
              minDate={startDate}
            />
          </Grid>

          <Grid item xs={6} md={2}>
            <label className="block text-white font-medium text-sm mb-1">
              Request Mode
            </label>
            <SelectDropdown
              fieldName="requestMode"
              options={[
                { label: "Select", value: "" },
                { label: "State", value: "state" },
                { label: "Central", value: "central" },
                // { label: "Private", value: "private" },
              ]}
              optionsLabelKey="label"
              optionsValueKey="id"
              register={register}
              onChange={handleRequestModeDropdown}
              errors={errors}
              fieldType="select"
              className="w-full border bg-white py-1.5 text-sm text-gray-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
              emptyOption={false}
            />
          </Grid>
          <Grid item xs={6} md={2}>
            <label className="block text-white font-medium text-sm mb-1">
              Request Type
            </label>
            <SelectDropdown
              fieldName="requestType"
              options={[
                { label: "Select", value: "" },
                { label: "Personal", value: "personal" },
                { label: "Community", value: "community" },
                { label: "Official", value: "official" },
                { label: "Medical", value: "medical" },
                { label: "Other", value: "other" },
              ]}
              optionsLabelKey="label"
              optionsValueKey="id"
              register={register}
              onChange={handleRequestTypeDropdown}
              errors={errors}
              fieldType="select"
              className="w-full border bg-white py-1.5 text-sm text-gray-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
              emptyOption={false}
            />
          </Grid>
          <Grid item xs={6} md={2}>
            <label className="block text-white font-medium text-sm mb-1">
              Filter by
            </label>
            {componentDisplay ? (
              componentDisplay()
            ) : (
              <div className="h-10 bg-gray-100 rounded-md"></div>
            )}
          </Grid>
          <Grid item xs={6} md={2}>
            <label className="block text-white font-medium text-sm mb-1">
              Search
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-3 flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  className="w-5 h-5 text-gray-500"
                >
                  <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </span>
              <input
                type="search"
                name="search"
                onChange={(e) => handleChangeSearch(e)}
                className="w-full py-1 pl-10 pr-4 border border-gray-500 rounded-md focus:border-primary-500 shadow-sm"
                placeholder="Search..."
              />
            </div>
          </Grid>
        </Grid>
      </div> */}

      <Grid container spacing={1} className="p-2">
        <Grid item xs={12}>
          <Card elevation={2} className="p-2 bg-blueBg rounded-lg ">
            <Grid container spacing={1}>
              {/* <Grid item xs={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  Start Date
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd MMM yyyy"
                  className="bg-white text-black px-2 py-1 rounded-md shadow-sm"
                  placeholderText="Start Date"
                />
              </Grid>
              <Grid item xs={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  End Date
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="dd MMM yyyy"
                  className="bg-white text-black px-2 py-1 rounded-md shadow-sm"
                  placeholderText="End Date"
                  minDate={startDate}
                />
              </Grid> */}
              <Grid item xs={12} sm={6} md={2.4}>
                <label className="block text-white font-medium text-sm mb-1">
                  Select Date
                </label>
                <DateRangePicker
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  startDate={startDate}
                  endDate={endDate}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2.4}>
                <label className="block text-white font-medium text-sm mb-1">
                  Request Mode
                </label>
                <SelectDropdown
                  fieldName="requestMode"
                  options={[
                    { label: "Select", value: "" },
                    { label: "State", value: "state" },
                    { label: "Central", value: "central" },
                    { label: "Private", value: "private" },
                  ]}
                  optionsLabelKey="label"
                  optionsValueKey="value"
                  register={register}

                  onChange={handleRequestModeDropdown}
                  errors={errors}
                  fieldType="select"
                  className="w-full border bg-white py-1.5 text-sm text-gray-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
                  emptyOption={false}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2.4}>
                <label className="block text-white font-medium text-sm mb-1">
                  Request Type
                </label>
                <SelectDropdown
                  fieldName={requestMode === "private"? "privateRequestType":"requestType"}
                  options={
                    requestMode === "private"
                      ? [
                          { label: "Select", value: "" },
                          {
                            label: "Employment",
                            value: "Employment",
                          },
                          {
                            label: "Help/Assistance",
                            value: "Help/Assistance",
                          },
                          {
                            label: "Other",
                            value: "other",
                          },
                        ]
                      : [
                          { label: "Select", value: "" },
                          { label: "Personal", value: "personal" },
                          { label: "Community", value: "community" },
                          { label: "Official", value: "official" },
                          { label: "Medical", value: "medical" },
                          { label: "Other", value: "other" },
                        ]
                  }
                  optionsLabelKey="label"
                  optionsValueKey="value"
                  register={register}
                  onChange={handleRequestTypeDropdown}
                  errors={errors}
                  fieldType="select"
                  className="w-full border bg-white py-1.5 text-sm text-gray-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
                  emptyOption={false}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2.4}>
                <label className="block text-white font-medium text-sm mb-1">
                  Filter by
                </label>
                {componentDisplay ? (
                  componentDisplay()
                ) : (
                  <div className="h-10 bg-gray-100 rounded-md"></div>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={2.4}>
                <label className="block text-white font-medium text-sm mb-1">
                  Search
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-3 flex items-center">
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="w-5 h-5 text-gray-500"
                    >
                      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                  </span>
                  <input
                    type="search"
                    name="search"
                    onChange={(e) => handleChangeSearch(e)}
                    className="w-full py-1 pl-10 pr-4 border border-gray-500 rounded-md focus:border-primary-500 shadow-sm"
                    placeholder="Search..."
                  />
                </div>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        {/* Stats Section (Cards) */}
        <Grid item xs={12}>
          <Card elevation={2} className="p-3 bg-white rounded-lg ">
            <Grid container spacing={2}>
              {stats.map((stat, index) => (
                <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                  <div className="text-center">
                    <Typography
                      variant="subtitle1"
                      className="text-gray-800 font-medium mb-1"
                    >
                      {stat.label}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{ color: stat.color }}
                      className={`font-extrabold capitalize`}
                    >
                      {stat.value < 10
                        ? `0${stat.value || 0}`
                        : stat.value || 0}
                    </Typography>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>

        {/* <Grid item xs={12}>
          <Card
            elevation={2}
            className="p-2 bg-white rounded-lg max-w-full overflow-auto"
          >
            <Typography variant="" className="text-gray-800 font-semibold">
              Ticket Summary
            </Typography>

            <TicketPivotTable pivotdata={pivotdata} />
          </Card>
        </Grid> */}
        <Grid item xs={12}>
          <Card elevation={2} className="p-2 bg-white rounded-lg">
            {/* <Typography variant="" className="text-gray-800 font-semibold">
              Tickets
            </Typography> */}
            <NavigationTab
              navTabs={tabsData}
              heading="Tickets"
              tab_1={
                <TicketsList
                  heading={false}
                  tableRowsData={newTicketsData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
              tab_2={
                <TicketsList
                  heading={false}
                  tableRowsData={inProgressData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
              tab_3={
                <TicketsList
                  heading={false}
                  tableRowsData={rejectedData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
              tab_4={
                <TicketsList
                  heading={false}
                  tableRowsData={resolvedData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
            />
          </Card>
        </Grid>
        <Grid item xs={12} md={5}>
          <Card elevation={2} className="p-2 bg-white rounded-lg">
            <div className="flex flex-wrap justify-between rounded-xl items-center gap-2">
              <Typography
                variant="h6"
                className="text-gray-800 font-semibold flex items-center"
              >
                <RiProgress6Line className="mr-2" /> Ticket Chart
              </Typography>

              <div className="flex items-center space-x-2 font-montsettat">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="state"
                    checked={requestCircularMode === "state"}
                    onChange={() => setRequestCircularMode("state")}
                    className="hidden peer"
                    name="requestCircularMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    State
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="central"
                    checked={requestCircularMode === "central"}
                    onChange={() => setRequestCircularMode("central")}
                    className="hidden peer"
                    name="requestCircularMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Central
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="private"
                    checked={requestCircularMode === "private"}
                    onChange={() => setRequestCircularMode("private")}
                    className="hidden peer"
                    name="requestCircularMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Private
                  </div>
                </label>
              </div>
            </div>

            <CircularChart
              // newTickets={newCount}
              // inProgress={inProgressCount}
              // rejected={rejectedCount}
              // resolved={resolvedCount}
              ticketData={pivotdata}
              requestCircularMode={requestCircularMode}
            />
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card elevation={2} className="p-2 bg-white rounded-lg">
            <div className="flex flex-wrap justify-between items-center gap-2">
              <Typography
                variant="h6"
                className="text-gray-800 font-semibold flex items-center"
              >
                <RiProgress6Line className="mr-2" /> Ticket Stats
              </Typography>

              <div className="flex items-center space-x-2 font-montsettat">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="state"
                    checked={requestBarMode === "state"}
                    onChange={() => setRequestBarMode("state")}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    State
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="central"
                    checked={requestBarMode === "central"}
                    onChange={() => setRequestBarMode("central")}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Central
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="private"
                    checked={requestBarMode === "private"}
                    onChange={() => setRequestBarMode("private")}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Private
                  </div>
                </label>
              </div>
            </div>
            <StackedBarChart
              ticketData={pivotdata}
              requestBarMode={requestBarMode}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default MPLadsDashboard;
